export const documentEn = {
  // BEGIN
  DOCUMENTS: 'Documents',
  SUBMIT_DOCUMENTS: 'Submit documents',
  DEBTOR: 'Debtor',
  LOAD_NO: 'Load No',
  INVOICE: 'Invoice',
  INVOICES: 'Invoices',
  TOTAL_RATE: 'Total rate',
  DATE: 'Date',
  RATE_CONFIRMATIONS_DOCTYPE: 'Rate confirmations',
  INVOICE_DOCTYPE: 'Invoice',
  BILL_OF_LADING_DOCTYPE: 'Bill of lading',
  OTHERS_DOCTYPE: 'Others',
  DEBTOR_NOT_MATCH: 'The debtor found in the document was not found in the valid list, select the correct one.',
  INVALID_DATE: 'Invalid date.',
  INVALID_ID: 'Invalid ID, it is not possible to load the data.',
  CONFIDENCE: 'Confidence',
  PREFERRED_PAYMENT_METHOD: 'Preferred payment method',

  // END
}

export const documentEs: typeof documentEn = {
  // BEGIN
  DOCUMENTS: 'Documentos',
  SUBMIT_DOCUMENTS: 'Enviar documentos',
  DEBTOR: 'Debtor',
  LOAD_NO: 'Número de carga',
  INVOICE: 'Factura',
  INVOICES: 'Facturas',
  TOTAL_RATE: 'Tarifa total',
  DATE: 'Fecha',
  RATE_CONFIRMATIONS_DOCTYPE: 'Confirmaciones de tarifas',
  INVOICE_DOCTYPE: 'Factura',
  BILL_OF_LADING_DOCTYPE: 'Guía de despacho',
  OTHERS_DOCTYPE: 'Otros',
  DEBTOR_NOT_MATCH:
    'El debtor encontrado en el documento no fue encontrado en la lista valida, selecciona el correcto.',
  INVALID_DATE: 'Fecha invalida.',
  INVALID_ID: 'Id no valido, no es posible cargar la data.',
  CONFIDENCE: 'Confianza',
  PREFERRED_PAYMENT_METHOD: 'Método de pago preferido',

  // END
}
